import { Trans, useLingui } from "@lingui/react/macro";
import { ArrowLeft } from "lucide-react";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";

import { AppModel } from "../../../app/app-model";
import { PageHeaderActions } from "../../../app/layout/layout-context";
import { Button } from "../../../components/ui-kit/base/button";
import { PatientSubpage } from "../common/patient-subpage";
import { PatientSettings } from "./patient-settings";

export const SettingsRoute = observer(function SettingsRoute(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  const location = useLocation();
  // Return to the tab the settings page was opened from (passed via link
  // state); fall back to the profile root on a cold load where state is lost.
  const backTo =
    (location.state as { settingsFrom?: string } | null)?.settingsFrom ??
    `/patient/${patient.patientId}`;
  return (
    <PatientSubpage title={t`Settings`}>
      {/* In the shared page-title row (next to "Patient #… / Settings"),
          matching the profile page's "Patient settings" button. */}
      <PageHeaderActions>
        <Button asChild variant="secondary" size="sm">
          <Link to={backTo}>
            <ArrowLeft className="size-4" />
            <Trans>Back to profile</Trans>
          </Link>
        </Button>
      </PageHeaderActions>
      {/* Settings keeps the page-title row (it shows no profile header, so the
          title is the only thing naming the page); this tightens the gap to it. */}
      <div className="-mt-4">
        <PatientSettings
          app={props.app}
          api={props.app.seerlinqApi}
          patient={patient}
        />
      </div>
    </PatientSubpage>
  );
});
